module.exports = __webpack_public_path__ + "media/playing_full_house_3.d265cf22.mp3";